<template>
  <section>
    <h1>Your Profile</h1>
    <hr/><br/>
    <div>
      <p><strong>Full Name:</strong> <span>{{ user.user_name || user.full_name }}</span></p>
      <p><strong>Username:</strong> <span>{{ user.user_username || user.username }}</span></p>
         <v-btn
            text="Delete Account (Tut!!!)"
            disabled
            @click="deleteAccount()"
          ></v-btn>

    </div>

  <div class="pa-4 text-center">
    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <template v-slot:activator="{ props: activatorProps }">
        <v-btn
          class="text-none font-weight-regular"
          prepend-icon="mdi-account"
          text="change Password"
          variant="tonal"
          v-bind="activatorProps"
        ></v-btn>
      </template>

      <v-card
        prepend-icon="mdi-account"
        title="Change Password"
      >
        <v-card-text>
          <PasswordChangeForm v-if="dialog" />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text="Close"
            variant="plain"
            @click="dialog = false"
          ></v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>


  </section>
</template>

<script>
import PasswordChangeForm from './PasswordChangeForm.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'ProfileScreen',
  components: { PasswordChangeForm },
    data: () => ({
      dialog: false,
    }),
  created: function() {
    return this.$store.dispatch('viewMe');
  },
  computed: {
    ...mapGetters({user: 'stateUser' }),
  },
  methods: {
    ...mapActions(['deleteUser']),
    async deleteAccount() {
      try {
        await this.deleteUser(this.user.id);
        await this.$store.dispatch('logOut');
        this.$router.push('/');
      } catch (error) {
        console.error(error);
      }
    }
  },
}
</script>
